/**
 * SECTION OrderListing filters panel logic
 */
import { IOrder } from "src/models/order";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class orderListingFilterMixin extends Vue {

  public searchInAttr: boolean = false;


  // NOTE: filter items by all select filter
  get filteredItems() {
    let filteredItems = this.getOrdersArray; //this.items

    if (this.selectedOrderType.length > 0) {
      filteredItems = filteredItems.filter((item) => {
        return this.selectedOrderType.includes(item.orderType);
      });
    }

    if (this.selectedOrderMarketPlace) {

      const currentMarket = this.availableOrderMarketplaces
      .find(m => m.id === this.selectedOrderMarketPlace);
      if (currentMarket && currentMarket.hasOwnProperty('marketplaceInstance')) {
        const hasntInstances = currentMarket.marketplaceInstance.length === 0
        if (hasntInstances) {
          filteredItems = filteredItems.filter((item) => {
            if (!this.isCombinedOrderListing)
              return item.marketplace === this.selectedOrderMarketPlace;
            else 
              return item.marketplace === currentMarket.name;
          });
        }
      }
 
      
    }

    if (this.selectInstancesMarketPlace.length > 0) {
      filteredItems = filteredItems.filter((item) => {
        return this.selectInstancesMarketPlace.includes(item.marketplaceInstance);
      });
    }

    return filteredItems;
  }

  // NOTE: get order statuses
  getAvailableStatuses() {
    return (
      this.orderStatus.length &&
      this.orderStatus
        .map((st) => {
          if (
            this.filteredItems &&
            this.filteredItems.flatMap((el: IOrder) => el.status).includes(st.nameTech)
          )
            return st;
        })
        .filter((item) => item !== undefined)
    );
  }
  // NOTE: get order types
  getAvailableOrderTypes() {
    return (
      (this.filteredItems && [
        ...new Map(
          this.filteredItems.map((v) => [JSON.stringify([v.orderType]), v])
        ).values(),
      ]) ||
      []
    );
  }
  // NOTE: get order marketplaces
  getAvailableOrderMarketplaces() {
    return (
      (this.marketplaces.length &&
        this.marketplaces
          .map((st) => {
            if (
              this.filteredItems &&
              this.filteredItems
                .flatMap((el: IOrder) => el.marketplace)
                .includes(st.id)
            )
              return st;
          })
        .filter((item) => item !== undefined)) ||
      []
    );
  }

  // NOTE: get marketplaceInstance
  get getAvailableMarketplaceInstances() {
    const currentMarketplace = this.availableOrderMarketplaces
      .filter((mp) => mp && this.selectedOrderMarketPlace === mp.id)
      .shift();
    if (currentMarketplace && currentMarketplace.marketplaceInstance.length === 1)
      this.selectInstancesMarketPlace = [currentMarketplace.marketplaceInstance[0].id];
    else this.selectInstancesMarketPlace = [];
    return currentMarketplace ? currentMarketplace.marketplaceInstance : []
  }

  // NOTE: config search
  searchByReferenceFields(searchData: { search: string, searchInAttr: boolean, searchAdvInAttr?: boolean }, IsCombo?: boolean) {
    const search = searchData.search;
    const searchInAttr = searchData.searchInAttr;
    const searchInAccountAttr = searchData.searchAdvInAttr;
    
    

    const orderTypeFields = {
      isDeleted: 0,
      operator: "AND",
      multi: {
        operator: "OR",
        id: { like: `%${search}%` },
        reference: { like: `%${search}%` },
        description: { like: `%${search}%` },
        contact: { like: `%${search}%` },
        notes: { like: `%${search}%` },
        status: { like: `%${search}%` }
      }
    }
    const comboTypeFields = {
      "o.isDeleted": 0,
      "operator": "AND",
      "multi": {
        "operator": "OR",
        "o.id": { like: `%${search}%` },
        "e.id": { like: `%${search}%` },
        "o.reference": { like: `${search}%` },
        "o.description": { like: `${search}%` },
        "o.status": { like: `${search}%` },
        "o.notes": { like: `${search}%` },
        "o.contact": { like: `${search}%` },
        "e.description": { like: `%${search}%` },
        "e.notes": { like: `${search}%` },
        "e.status": { like: `${search}%` }
      }
    }

    if (searchInAttr) {
      !IsCombo ?
        Object.assign(orderTypeFields.multi, { 'oa.value': { like: `%${search}%` }}) :
        Object.assign(comboTypeFields.multi, { 'oa.value': { like: `%${search}%` } })

    }

    if (searchInAccountAttr) {
      !IsCombo ?
        Object.assign(
          orderTypeFields.multi, 
          { 'account.contact': { like: `%${search}%` }, 'account.business': { like: `%${search}%` } }) :
        Object.assign(
          comboTypeFields.multi,
          { 'account.contact': { like: `%${search}%` }, 'account.business': { like: `%${search}%` } })
    }

    return !IsCombo ? orderTypeFields : comboTypeFields;
  }


  get isCombinedOrderListing(): boolean {
    return this.localTypeStatus == "combo";
  }

}//


